import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
    providedIn: 'root'
})

export class FloorTableService extends DatabaseGwService{
    URL_PATH: string = '/floor-tables';
}